// Mapea los morphs de la API (MorphDTO[]) al formato interno esperado
export function mapMorphsFromDTO(morphs: any[]): any[] {
  return morphs.map((morph) => ({
    default: morph.valor ?? 0,
    _default: morph.valor ?? 0,
    morphId: morph.idMorph ?? 0,
    order: morph.orden ?? 0,
    type: morph.tipo ?? '',
    min: morph.valorMin ?? 0,
    max: morph.valorMax ?? 0,
    name: morph.nombre ?? '',
    show: true,
    modifyable: true,
  }))
}
